import React, { memo } from 'react';
import PropTypes from 'prop-types';

const folderTones = ['#FBFAF7', '#F7F4EC', '#F4F0E6', '#FAF6EF', '#F6F2E9'];

const FolderCard = memo(({ folder, onClick }) => {
  const isEmpty = folder.clipCount === 0;
  const tone = folderTones[folder.name.length % folderTones.length];
  const borderColor = isEmpty ? 'rgba(0,0,0,0.06)' : 'rgba(0,0,0,0.09)';

  return (
    <button onClick={() => onClick(folder)} className="w-full text-left group">
      <article className="relative pt-[11px] transition-all group-active:scale-[0.97]">
        {/* Folder tab */}
        <div
          className="absolute top-0 left-3"
          style={{
            width: '52px',
            height: '11px',
            backgroundColor: tone,
            border: `1px solid ${borderColor}`,
            borderBottom: 'none',
            borderRadius: '4px 4px 0 0',
          }}
          aria-hidden
        />
        {/* Card body */}
        <div
          className="relative h-[88px] flex flex-col justify-end px-3.5 pb-3 rounded-[8px]"
          style={{
            backgroundColor: tone,
            border: `1px solid ${borderColor}`,
            boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
          }}
        >
          <div className="flex items-end justify-between gap-2">
            <h3
              className="font-instrument text-[20px] leading-tight"
              style={{ color: isEmpty ? 'rgba(0,0,0,0.40)' : '#111' }}
            >
              {folder.name}
            </h3>
            <span
              className="text-[10px] font-semibold pb-0.5"
              style={{ letterSpacing: '1px', color: 'rgba(0,0,0,0.30)' }}
            >
              {String(folder.clipCount).padStart(2, '0')}
            </span>
          </div>
        </div>
      </article>
    </button>
  );
});

FolderCard.displayName = 'FolderCard';

FolderCard.propTypes = {
  folder: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    clipCount: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FolderCard;
